import { render, staticRenderFns } from "./RetentionReport.vue?vue&type=template&id=1990c8de&scoped=true"
import script from "./RetentionReport.vue?vue&type=script&lang=ts"
export * from "./RetentionReport.vue?vue&type=script&lang=ts"
import style0 from "./RetentionReport.vue?vue&type=style&index=0&id=1990c8de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1990c8de",
  null
  
)

export default component.exports